var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Breadcrumbs',{attrs:{"main":"Dashboard","title":"Kontrol Paneli"}}),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('TurRezervasyonList')],1)])]),_c('DuyuruGosterimModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }